import LandingPage from 'views/Landing/LandingPage'
export default LandingPage
